import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import StoreMallDirectoryRoundedIcon from '@mui/icons-material/StoreMallDirectoryRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssuredWorkloadRoundedIcon from '@mui/icons-material/AssuredWorkloadRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';

import { BasicFlex, Notes } from '../../../utils/Common';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

// utils
import { formatPhoneNumber, formatCurrency } from '../../../utils/util';

const Balance = styled.div`
  font-size: 2.4rem;
  font-weight: 600;
`

const ProfileTab = () => {
  const { data = {} } = usePageData();

  const businessBlock = [
    {header: "Company Name", info: data.company_name},
    {header: "Brand", info: data.brand_name},
  ];

  const detailsBlock = [
    {header: "Name", icon: <AccountBoxOutlinedIcon fontSize='small' />, info: data.full_name},
    {header: "Email", icon: <EmailOutlinedIcon fontSize='small' />, info: data.email},
    {header: "Mobile", icon: <PhoneOutlinedIcon fontSize='small' />, info: formatPhoneNumber(data.mobile_phone)},
  ];

  const addressBlock = [
    {header: "Address", icon: <LocationOnOutlinedIcon fontSize='small' />, align: "flex-start", info: `${data.address}, ${data.city}, ${data.state}, ${data.country}`},
  ];

  const activityBlock = [
    {header: "Active", info: data.is_active, dataType: "boolean", booleanValues: ["Active", "Inactive"]},
    {header: "Date Created", info: data.created_at, dataType: "date"},
  ];

  const inventoryBlock = [
    { header: "Wigs in Stock", icon: <StoreMallDirectoryRoundedIcon fontSize='small' />, info: data.inventory.stock, dataType: "number", spread: "15rem" },
    { header: "Wigs Sold", icon: <ReceiptRoundedIcon fontSize='small' />, info: data.inventory.sold, dataType: "number", spread: "15rem" },
  ]

  const balanceBlock = [
    {header: "Balance", icon: <AccountBalanceWalletOutlinedIcon fontSize='small' />, dataType: "currency", info: data.balance},
    // {header: "Wallet", icon: <AssuredWorkloadRoundedIcon fontSize='small' />, dataType: "currency", info: data.wallet},
  ];

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" />
          <CardContent>
            <CardBlockContainer>
              <CardBlockHeader>Business Information</CardBlockHeader>
              {businessBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Contact Information</CardBlockHeader>
              {detailsBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />

              <CardBlockHeader>Address</CardBlockHeader>
              {addressBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Activity</CardBlockHeader>
              {activityBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Notes</CardBlockHeader>
              <Notes>{data.notes}</Notes>
        
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

       <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Inventory Summary" />
          <CardContent>
            <CardBlockContainer>
              {inventoryBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

       <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Vendor Balance"
            action={
              <Link to={`/vendor_payments/edit`} state={{vendor_id: data.vendor_id?.toString(), vendor_name: data.full_name, mobile_phone: data.mobile_phone, email: data.email}} >
                <Button variant='contained' size='small' startIcon={<PaymentsRoundedIcon />}>Pay Now</Button>
              </Link>
            }
            sx={{gap: "6rem"}}
          />
          <CardContent sx={{pt: 0}}>
            <Balance>{formatCurrency(data.balance)}</Balance>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 8}}>
        <Card variant='outlined'>
          <CardHeader title={<BasicFlex gap="1rem">Vendor History <HistoryRoundedIcon /></BasicFlex>} />
          <CardContent>
            Timeline goes here
          </CardContent>
        </Card>
      </Grid>

     
    </Grid>
  );

};

export default ProfileTab;